import bgBtnLogin from "../../../assets/web-v3-images/btn-login.png";
import { handleNumericInput } from "@/helper/helper";
import BackgroundLogin from "./BackgroundLogin";
import BackgroundBody from "./BackgroundBody";
import LoginUserPass from "./user-pass";
import LoginOtp from "./otp";
import React, { useEffect } from "react";
import { TYPE_LOGIN } from "@/helper/const";
import OTPInput from "react-otp-input";
import styled from "styled-components";
import Eye from "../../../assets/web-v3-images/eye.png";
import EyeOff from "../../../assets/web-v3-images/solar_eye-closed-bold.png";
import { Trans, useTranslation } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { getIsdnNoNationalCode } from '@/utils/helper';
const ContainerLoginOTP = styled.div`
  .container-otp-input {
    width: 100%;
    margin-top: 15.3px;
    div {
      width: 100%;
      justify-content: space-between;
      input {
        font-size: 40px;
        color: #fefaf5;
        text-align: center;
      }
      input:focus-visible {
        outline: 4px solid rgb(195, 100, 79);
      }
    }
  }
`;

function InputField({
  value,
  handleChangeValue,
  label,
  placeholder,
  type = "text",
  setShowPassword = () => { },
  showPassword = false,
  isShowIcon = false,
  isShowError = false,
}) {
  const { t } = useTranslation()
  const inputRef = React.useRef(null);
  useEffect(() => {
    if (isShowError) {
      inputRef.current?.focus();
    }
  }, [isShowError]);
  console.log(type);


  return (
    <div
      className="relative content-stretch flex flex-col gap-[15.3px] items-start relative shrink-0 w-full"
      data-name="Input field"
    >
      <div
        className="content-stretch flex flex-col gap-[15.3px] items-start relative shrink-0 w-full"
        data-name="Input with label"
      >
        <div
          className="content-stretch flex gap-[5.1px] items-start relative shrink-0"
          data-name="Label wrapper"
        >
          <p
            className="[word-break:break-word] bg-clip-text font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[36px] text-[transparent] whitespace-nowrap"
            style={{
              backgroundImage:
                "linear-gradient(180deg, rgb(252, 252, 217) 50.336%, rgb(253, 253, 187) 100%), linear-gradient(90deg, rgb(254, 253, 240) 0%, rgb(254, 253, 240) 100%)",
            }}
          >
            {label}
          </p>
        </div>
        <div
          className={`bg-[#772917] drop-shadow-[0px_2.55px_2.55px_rgba(10,13,18,0.05)] relative rounded-[32px] shrink-0 w-full ${isShowError ? "border-2 border-red-500" : ""}`}
          data-name="Input"
        >
          <div
            aria-hidden
            className="absolute border-[#932f19] border-[2.55px] border-solid inset-0 pointer-events-none rounded-[32px]"
          />
          <div className="flex flex-row items-center size-full">
            <div className="content-stretch flex gap-[20.4px] items-center px-[35.7px] py-[25.5px] relative size-full">
              <div
                className="content-stretch flex flex-[1_0_0] gap-[20.4px] items-center min-w-px relative"
                data-name="Content"
              >
                <p className="[word-break:break-word] opacity-0 flex-[1_0_0] font-['Inter:Regular',sans-serif] font-normal leading-[61.2px] min-w-px not-italic overflow-hidden relative text-[40px] text-[rgba(254,250,245,0.35)] text-ellipsis whitespace-nowrap">
                  {placeholder}
                </p>
                <input
                  type={type}
                  placeholder={placeholder}
                  className={`absolute inset-0 w-full h-full bg-transparent border-0 outline-none text-[40px] text-[#FEFAF5] px-0 ${isShowIcon ? "pr-20" : ""}`}
                  onChange={(e) => handleChangeValue(e)}
                  // inputMode={`${isShowIcon ? "text" : "numeric"}`}

                  value={value}
                  ref={inputRef}
                  autoFocus
                />
                {isShowIcon && (
                  <div
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="
                      absolute
                      right-[-10px]
                      top-1/2
                      -translate-y-1/2
                      p-2
                      text-white/60
                      hover:text-white
                      transition-colors btn-click-active
                    "
                  >
                    {showPassword ? <img src={Eye} /> : <img src={EyeOff} />}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isShowError &&
        <span className='text-[23px] italic text-[#fff] absolute -bottom-9'>
          {type === 'number' ? t("modal.modal_login.please_your_mytel_number") : t("modal.modal_login.please_your_mytel_password")}
        </span>
      }
    </div>
  );
}

function ConponentButton({ handleAction, content = "", isLoadingBtn }) {
  return (
    <div
      className="content-stretch btn-click-active relative flex w-full items-center"
      onClick={handleAction}
      style={{
        pointerEvents: isLoadingBtn ? "none" : "",
        opacity: isLoadingBtn ? 0.6 : 1,
      }}
    >
      <div>
        <img src={bgBtnLogin} alt="" />
      </div>

      <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-3 font-['Inter:Extra_Bold',sans-serif] text-[36px] font-extrabold tracking-[0.36px] text-[#fefbe8]">
        {isLoadingBtn && (
          <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-[#fefbe8] border-t-transparent" />
        )}

        <p className="leading-none whitespace-nowrap">{content}</p>
      </div>
    </div>
  );
}

function ContentOr() {
  const { t } = useTranslation();
  return (
    <div className="content-stretch flex gap-[28px] items-center relative shrink-0 w-full">
      <div className="flex-[1_0_0] h-0 min-w-px relative">
        <div className="absolute inset-[-0.5px_0]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 361.5 1"
          >
            <path
              d="M0 0.5H361.5"
              id="Vector 22"
              stroke="var(--stroke-0, #FEFAF5)"
              strokeOpacity="0.35"
            />
          </svg>
        </div>
      </div>
      <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#fefdf0] text-[36px] whitespace-nowrap">
        {t("or")}
      </p>
      <div className="flex-[1_0_0] h-0 min-w-px relative">
        <div className="absolute inset-[-0.5px_0]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 361.5 1"
          >
            <path
              d="M0 0.5H361.5"
              id="Vector 22"
              stroke="var(--stroke-0, #FEFAF5)"
              strokeOpacity="0.35"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

function DefaultLogin({
  phoneNumber,
  setPhoneNumber,
  setTypeLogin,
  handleLoginWith = () => { },
  errorInputPhoneNumber,
  setErrorInputPhoneNumber,
  handleOk = () => { },
}) {
  const { t, i18n } = useTranslation();

  const isValidPhoneNumber = (value) => {
    const noNationalCode = getIsdnNoNationalCode(value);
    return /^\d{9,10}$/.test(noNationalCode);
  }

  const handlePhoneNumberChange = (event) => {
    const rawValue = event.target.value;
    const numericValue = handleNumericInput(rawValue);
    setPhoneNumber(numericValue);
  }

  const handleValidateBeforeAction = (action) => {
    if (!isValidPhoneNumber(phoneNumber)) {
      setErrorInputPhoneNumber(true);
      return;
    }
    setErrorInputPhoneNumber(false);
    action();
  };

  return (
    <div
      className={`-translate-x-1/2 absolute bottom-[45.7px] content-stretch flex flex-col gap-[58px] items-center left-1/2  w-[816px] ${i18n.language === "my" ? "py-[325px]" : "py-[325px]"} `}
    >
      <p
        className={`relative inline-block pb-2  px-[1.5cqw] text-transparent bg-linear-to-b from-[#FDFDBB] to-[#FCFCD9] bg-clip-text font-['Inter:Extra_Bold',sans-serif] font-extrabold leading-[normal] not-italic  text-[74px] text-center w-full ${i18n.language === "my" ? "my-[-70px]" : ""}`}
      >
        {t("header.login")}
      </p>
      <InputField
        value={phoneNumber}
        handleChangeValue={handlePhoneNumberChange}
        label={t("modal.modal_login.phone_number")}
        placeholder={t("modal.modal_login.phone_number_placeholder")}
        isShowError={errorInputPhoneNumber}
        type="number"
      />
      <div className="content-stretch flex flex-col gap-[24px] items-start relative shrink-0 w-full">
        <ConponentButton
          handleAction={() => {
            handleValidateBeforeAction(() => {
              handleLoginWith(TYPE_LOGIN.loginOtp);
              handleOk(TYPE_LOGIN.loginOtp);
            })
          }}
          content={t("modal.modal_login.title_otp")}
        />
        <ContentOr />
        <ConponentButton
          handleAction={() =>
            handleValidateBeforeAction(() => {
              handleLoginWith(TYPE_LOGIN.loginPassword)
            })
          }
          content={t("login_width_password")}
        />
      </div>
    </div>
  );
}

export function BodyLoginWidthPassword({
  password,
  showPassword,
  setShowPassword,
  handleChangePassword,
  errorInputPassword,
  handleLoginUserPass,
  isLoadingBtn,
}) {
  const { t, i18n } = useTranslation();

  return (
    <div className="-translate-x-1/2 absolute bottom-[235.7px] content-stretch flex flex-col gap-[58px] items-center left-1/2 py-[380px] w-[816px]">
      <p
        className={`relative inline-block pb-2  px-[1.5cqw] text-transparent bg-linear-to-b from-[#FDFDBB] to-[#FCFCD9] bg-clip-text font-['Inter:Extra_Bold',sans-serif] font-extrabold leading-[normal] not-italic  text-[74px] text-center w-full ${i18n.language === "my" ? "my-[-70px]" : ""}`}
        style={{
          backgroundImage:
            "linear-gradient(rgb(253, 253, 187) 50.336%, rgb(252, 252, 217) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      >
        {t("password_login")}
      </p>
      <InputField
        value={password}
        handleChangeValue={handleChangePassword}
        label={t("modal.modal_login.password")}
        placeholder={t("modal.modal_login.password_placeholder")}
        type={showPassword ? "text" : "password"}
        setShowPassword={setShowPassword}
        showPassword={showPassword}
        isShowIcon
        isShowError={errorInputPassword}
      />
      <div className="relative content-stretch flex flex-col gap-[24px] items-start relative shrink-0 w-full">
        <ConponentButton
          handleAction={handleLoginUserPass}
          content={t("modal.modal_login.confirm")}
          isLoadingBtn={isLoadingBtn}
        />
      </div>
    </div>
  );
}

export function BodyLoginWidthOTP({
  phoneNumber,
  otp,
  setOtp,
  handleLoginOtp,

  countdown,
  isLoadingBtn,
  handleOk,
}) {
  const { t, i18n } = useTranslation();

  return (
    <>
      <ContainerLoginOTP
        className={`-translate-x-1/2 absolute bottom-[160.7px] content-stretch flex flex-col gap-[68px] items-center left-1/2  w-[816px] ${i18n.language === "my" ? "py-[400px]" : "py-[455px]"}`}
      >
        <p
          className={`relative inline-block pb-2  px-[1.5cqw] text-transparent bg-linear-to-b from-[#FDFDBB] to-[#FCFCD9] bg-clip-text font-['Inter:Extra_Bold',sans-serif] font-extrabold leading-[normal] not-italic  text-[74px] text-center w-full ${i18n.language === "my" ? "h-[150px]" : ""}`}
        >
          {t("modal.modal_login.title_confirm_otp")}
        </p>
        <div
          className="content-stretch flex flex-col gap-[15.3px] items-start relative shrink-0 w-full"
          data-name="Input field"
        >
          <div
            className="content-stretch flex flex-col gap-[15.3px] items-start relative shrink-0 w-full"
            data-name="Input with label"
          >
            <div
              className="content-stretch flex gap-[5.1px] items-start relative shrink-0"
              data-name="Label wrapper"
            >
              <p
                className="[word-break:break-word] bg-clip-text font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[58px] not-italic relative text-[36px] text-transparent"
                style={{
                  backgroundImage:
                    "linear-gradient(180deg, rgb(252, 252, 217) 50.336%, rgb(253, 253, 187) 100%), linear-gradient(90deg, rgb(254, 253, 240) 0%, rgb(254, 253, 240) 100%)",
                }}
              >
                {i18n.language === "my" ? (
                  <>
                    {t("we_sent_code")} &nbsp;
                    {phoneNumber}
                  </>
                ) : (
                  <>
                    {" "}
                    {t("we_sent_code")} &nbsp;
                    <br />
                    {phoneNumber}
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="container-otp-input">
            <OTPInput
              value={otp}
              onChange={(e) => {
                // setOtp(e.replace(/\D/g, ""));
                setOtp(e);
              }}
              numInputs={6}
              shouldAutoFocus
              renderInput={(props) => (
                <input
                  {...props}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  style={{
                    width: "123.5px",
                    backgroundColor: "#772917",
                    height: "127px",
                    borderRadius: "32px",
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="relative content-stretch flex flex-col gap-[24px] items-start shrink-0 w-full">
          {/* <ConponentButton
            handleAction={handleLoginOtp}
            content={t("modal.modal_login.confirm")}
            isLoadingBtn={isLoadingBtn}
          /> */}
          <div
            style={{
              position: "absolute",
              bottom: "-100px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <p
              className="[word-break:break-word] bg-clip-text font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[36px] text-[transparent] whitespace-nowrap"
              style={{ color: "white" }}
            >
              {/* Didn't receive the code? Resend (60s) */}
              <>
                {" "}
                {!countdown ? (
                  <div className="label-input relative">
                    {t("modal.modal_login.resend_otp")}{" "}
                    <span
                      onClick={() => handleOk(TYPE_LOGIN.loginOtp)}
                      style={{
                        pointerEvents: `${isLoadingBtn ? "none" : ""}`,
                        cursor: "pointer",
                      }}
                    >
                      {t("modal.modal_login.resend")}{" "}
                      {isLoadingBtn && isLoadingBtn !== 2 ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "-30px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <Spin
                            style={{ color: "white" }}
                            indicator={
                              <LoadingOutlined style={{ fontSize: 18 }} spin />
                            }
                          />{" "}
                        </div>
                      ) : null}
                    </span>
                  </div>
                ) : (
                  <div className="label-input" style={{ position: "relative" }}>
                    {t("modal.modal_login.please_resend_OTP_after_NUM_seconds_1")}
                    <span
                      style={{
                        pointerEvents: `${isLoadingBtn ? "none" : ""}`,
                        textDecoration: "none",
                      }}
                    >
                      {" "}
                      {countdown}{" "}
                      {isLoadingBtn && isLoadingBtn !== 2 ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "-30px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <Spin
                            style={{ color: "white" }}
                            indicator={
                              <LoadingOutlined style={{ fontSize: 24 }} spin />
                            }
                          />{" "}
                        </div>
                      ) : null}
                    </span>
                    {t("modal.modal_login.please_resend_OTP_after_NUM_seconds_2")}
                  </div>
                )}
              </>
            </p>
          </div>
        </div>
      </ContainerLoginOTP>
    </>
  );
}

export default function ComponentLogin({
  phoneNumber,
  setPhoneNumber,
  typeLogin,
  setTypeLogin,
  handleLoginWith = () => { },
  errorInputPhoneNumber,
  setErrorInputPhoneNumber,

  handleOk,
  password,
  setPassword,
  otp,
  setOtp,
  handleLoginOtp,
  countdown,
  isLoadingBtn,
  handleBack,
}) {
  const handleGetTabs = () => {
    switch (typeLogin) {
      case TYPE_LOGIN.default:
        return (
          <DefaultLogin
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            setTypeLogin={setTypeLogin}
            handleLoginWith={handleLoginWith}
            errorInputPhoneNumber={errorInputPhoneNumber}
            setErrorInputPhoneNumber={setErrorInputPhoneNumber}
            handleOk={handleOk}
          />
        );
      case TYPE_LOGIN.loginPassword:
        return (
          <LoginUserPass
            handleOk={handleOk}
            setPassword={setPassword}
            password={password}
            isLoadingBtn={isLoadingBtn}
          />
        );
      case TYPE_LOGIN.loginOtp:
        return (
          <LoginOtp
            phoneNumber={phoneNumber}
            otp={otp}
            setOtp={setOtp}
            handleLoginOtp={handleLoginOtp}
            countdown={countdown}
            isLoadingBtn={isLoadingBtn}
            handleOk={handleOk}
            setTypeLogin={setTypeLogin}
          />
        );
      default:
        return null;
    }
  };
  return (
    <ContainerMain
      className="relative size-full"
      style={{
        backgroundImage:
          "linear-gradient(rgb(253, 236, 197) 0%, rgb(254, 199, 144) 93.436%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
      data-name="Phone number"
    >
      <BackgroundLogin
        isShowButtonBack={typeLogin === TYPE_LOGIN.default ? false : true}
        handleBack={handleBack}
      />
      <BackgroundBody />
      {handleGetTabs()}
    </ContainerMain>
  );
}

const ContainerMain = styled.div`
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  /* Chrome, Edge, Safari */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #772917 inset !important;
    -webkit-text-fill-color: #fff !important;
    caret-color: #fff;
    border: none;
    transition: background-color 9999s ease-in-out 0s;
  }
`;
